const API_BASE = (process.env.REACT_APP_API_BASE || "http://localhost:5000").replace(/\/$/, "");

async function readJson(res: Response) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.message || "Request failed.");
  }
  return data;
}

export async function generateRecoveryPhrase(): Promise<string> {
  const res = await fetch(`${API_BASE}/api/auth/recovery-phrase/generate`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    cache: "no-store",
  });
  const data = await readJson(res);
  const phrase = typeof data?.phrase === "string" ? data.phrase.trim() : "";
  if (!phrase) throw new Error("Could not generate a recovery phrase.");
  return phrase;
}

export async function recoverPassword(payload: {
  username: string;
  recoveryPhrase: string;
  newPassword: string;
}): Promise<{ success: boolean; message?: string }> {
  const res = await fetch(`${API_BASE}/api/auth/recover-password`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    cache: "no-store",
  });
  return readJson(res);
}
